import React, { useCallback, useEffect, useRef, useState } from 'react';
import './Testimonials.css';

function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [slideStride, setSlideStride] = useState(0);
  const trackRef = useRef(null);

  const testimonials = [
    {
      text: "Du bist ein wirklicher Zauberer, es ist ein so einheitlicher schöner Klang entstanden. Die Lieder so zu hören, wie sie wir uns vorgestellt haben, löst wirklich Glücksgefühle aus. Danke für deine hochkompetente Arbeit und die schöne gemeinsame Arbeitsatmosphäre in deinem Studio.",
      author: "Markus Sturz, Tina Köhn – 'New Morning'"
    },
    {
      text: "Die technischen Fähigkeiten und das exzellente Ohr von Matthias sind herausragend und geben eine enorme Sicherheit. Doch noch über all dem liegt für mich sein feines Gespür für meine Musik, mit dem er sich in jedes Stück ganz tief einfühlt. Das ermöglicht einen Austausch, den ich so nie für möglich gehalten hätte. Er verleiht jeder Produktion Tiefe.",
      author: "Thomas Lambrich"
    },
    {
      text: "Nichts geht ohne Hilfe. Und so bedanke ich mich bei Matthias, Hamburger Tonmeister, der mit seiner 'Milchkettenmusik' alles aufgenommen hat, singen und spielen in einem Take. Nicht einfach so, sondern so, wie ich es bei dem lange verstorbenen Conny Plank erlebte. (...) ",
      author: "Rainer Pruess"
    },
    {
      text: "Perfekter Dreiklang ! Ein traumhaft klingender Seiler Flügel 278 – gespielt von einer traumwandlerisch betörend spielenden Ella Krohn – in absoluter Referenzqualität aufgenommen – ein seltenes musikalisches und künstlerisches Meisterwerk !",
      author: "Jürgen Beckers – monitor db"
    },
    {
      text: "Ich war in den letzten Jahren häufig in der Milchkette zu Gast und bin jedes mal hervorragend betreut worden durch Matti (der im übrigen auch Drummer ist!). Die Räume klingen toll, der Workflow ist schnell, die Musik steht immer ohne Umwege an erster Stelle. Ich freue mich aufs nächste Mal, Empfehlung an die Kollegen!",
      author: "Heinz Lichius"
    },
    {
      text: "Du hast SUMMERS EASE so großartig gemischt und die Arbeit mit Dir machte uns allen enormen Spaß. Ich denke das hört man auch! In super entspannter -Tageslicht durchfluteter Studio – Atmosphäre, mit einem immer freundlichen Tonmeister, das hinterlässt Spuren. Herzlichen Dank, ich komme wieder",
      author: "Caro Josée (Jazz Echo)"
    },
    {
      text: "(...) Mattis 'Das wird schon, wart's nur ab' wollte ich keinen Glauben schenken. Aber er hatte recht! Nachdem er mit unglaublich viel Geduld und einer beeindruckenden Mixtur aus gutem Ohr und stets frischen Ideen unsere Aufnahmen abgemischt hatte, fand ich das Konzert und die Band auf einmal genial und musste wieder einmal erkennen: C'est le ton qui fait la musique! Und den macht beileibe nicht nur die Band! Danke Matti, du bist großartig!",
      author: "Eva – EVANTGARDE"
    }
  ];

  const updateLayoutMetrics = useCallback(() => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);

    if (!trackRef.current) {
      return;
    }

    const firstSlide = trackRef.current.querySelector('.testimonial');
    if (!firstSlide) {
      return;
    }

    const trackStyles = window.getComputedStyle(trackRef.current);
    const gapValue = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    const width = firstSlide.getBoundingClientRect().width;

    setSlideStride(width + gapValue);
  }, []);

  useEffect(() => {
    updateLayoutMetrics();
    window.addEventListener('resize', updateLayoutMetrics);
    return () => window.removeEventListener('resize', updateLayoutMetrics);
  }, [updateLayoutMetrics]);

  const visibleCount = isMobile ? 1 : 3;
  const maxIndex = Math.max(testimonials.length - visibleCount, 0);

  useEffect(() => {
    setCurrentIndex((prev) => Math.min(prev, maxIndex));
  }, [maxIndex]);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prev) => {
      if (maxIndex === 0) {
        return 0;
      }
      return prev === 0 ? maxIndex : prev - 1;
    });
  }, [maxIndex]);

  const handleNext = useCallback(() => {
    setCurrentIndex((prev) => {
      if (maxIndex === 0) {
        return 0;
      }
      return prev === maxIndex ? 0 : prev + 1;
    });
  }, [maxIndex]);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  // Erstelle Array für Dots (nur so viele wie wirklich nötig)
  const dotsArray = Array.from({ length: maxIndex + 1 }, (_, i) => i);

  useEffect(() => {
    if (isPaused || maxIndex === 0) {
      return;
    }
    const interval = setInterval(handleNext, 4000);
    return () => clearInterval(interval);
  }, [handleNext, isPaused, maxIndex]);

  return (
    <section id="referenzen" className="testimonials">
      <button className="arrow arrow-left" onClick={handlePrev}>‹</button>
      <div 
        className="testimonials-wrapper"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div 
          ref={trackRef}
          className="testimonials-track"
          style={{
            transform: slideStride
              ? `translateX(-${currentIndex * slideStride}px)`
              : 'translateX(0)'
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">{testimonial.text}</p>
              <p className="testimonial-author">{testimonial.author}</p>
            </div>
          ))}
        </div>
      </div>
      <button className="arrow arrow-right" onClick={handleNext}>›</button>
      <div className="dots">
        {dotsArray.map((index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
